export default "__VITE_ASSET__BOrYCNk___"